import React, { useState, useEffect, useMemo, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FaList } from "react-icons/fa";
import { MdDateRange, MdOutlineAssignmentReturned } from "react-icons/md";
import ContentBlock from "../components/Layout/ContentBlock";
import {
  colorBlockShipment,
  errorHandler,
  exportDocument,
  prettyDateFormat,
  uniqueArray,
} from "../helpers/Utils";
import TextInputModal from "../components/common/TextInputModal";
import { SelectForm } from "../components/common/Buttons";
import Spinner from "../components/common/Spinner";
import Container from "../components/Layout/Container";
import {
  createTrRequestItem,
  exportTrRequests,
  getTrRequest,
  getTrRequestItem,
  removeMTrRequestItem,
  updateTrRequestItem,
} from "../redux/Actions/tr_requests_action";
import {
  IconCancel,
  IconDot,
  IconExclamation,
  XIcon,
} from "../components/Layout/Icons";
import { Modal, Spin, Tooltip, Checkbox, Input } from "antd";
import bigboxicon from "../../assets/images/bigboxicon.svg";
import useDebounce from "../hooks/useDebounce";
const { confirm } = Modal;
import ShipmentStoreSvg from "../../assets/images/shipment/shipment_store.svg";
import { MdCallSplit } from "react-icons/md";
import SelectInput from "../components/common/SelectInput";
import TrShipmentComponentIndex from "../components/orders/accepted_orders/items/TrShipmentComponentIndex";
import {
  have_product_reference,
  isOrderRowCod,
  possibilityToAssignDeliveryAmount,
} from "../helpers/OrdersFunctionsGlobal";
import TableFilterBox from "../components/common/TableFilterBox";
import { AiOutlinePlus } from "react-icons/ai";
import { DebounceSelect } from "../components/common";
import Axios from "axios";
import OrderRowAdd from "../components/common/GlobalModals/Orders/editModal/order_row/order_row_add";
import { createRef } from "react";
import RegularOrderChildren from "../components/common/GlobalModals/Orders/RegularOrderChildren";
import { getOrder } from "../redux/Actions/orderAction";
import TextAreaFieldGroup from "../components/common/TextAreaFieldGroup";
import { last_arr } from "../helpers/array";
import axios from "axios";
import { antdMessageError, antdMessageSuccess } from "../helpers/Utils";
import { v4 as uuidv4 } from "uuid";
import { MdEdit, MdClose, MdAutorenew } from "react-icons/md";
import { QueryClient, QueryClientProvider, useMutation } from "react-query";
import { useFetch } from "../hooks";
import VvDepartmentPopover from "../components/Products/Items/VvDepartmentPopover";

const initialFilterState = {
  department_name: undefined,
  shipping_method: undefined,
  good: "",
  pickup_address: undefined,
};

const shipmentMethodOptions = [
  "Bigbox",
  "DPD",
  "Omniva",
  "Venipak",
  "LP Exp",
  "Atsiėmimas ofise",
  "Matkahuolto",
  "Posti",
  "Itella",
];

const queryClient = new QueryClient();

function TrRequestIdScreen({ match, history }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TrRequestIdScreenContent match={match} history={history} />
    </QueryClientProvider>
  );
}

function TrRequestIdScreenContent({ match, history }) {
  const dispatch = useDispatch();
  const { loading, show_data } = useSelector((state) => state.custom);
  const modalRef = createRef();
  const [filters, setFilters] = useState(initialFilterState);
  const [searchActive, setSearchActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [order_id, set_order_id] = useState(null);
  const [checkedItems, setCheckedItems] = useState([]);
  const [showData, setShowData] = useState(show_data);
  const [editingDepartment, setEditingDepartment] = useState(null);

  const {
    value: valueStores,
    loading: loadingStores,
  } = useFetch(`/api/v1/also_incomes/vv_stores`);

  const updateDepartmentMutation = useMutation({
    mutationFn: ({ itemId, department_code, department_name }) => {
      return Axios.put(`/api/v1/tr_request_items/${itemId}`, {
        tr_request_item: {
          department_code,
          department_name,
        },
      });
    },
    onSuccess: () => {
      antdMessageSuccess("Department updated successfully");
      setEditingDepartment(null);
      dispatch(getTrRequest(match.params.show));
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message || "Failed to update department");
    },
  });



  const getDepartmentOptions = () => {
    const stores = valueStores?.stores?.["verslo vartai"] || {};
    const options = Object.entries(stores).map(([key, value]) => {
      const code = key.replace('vv_', '');
      return {
        value: key,
        label: value,
        code: code,
      };
    });

    return [
      {
        value: '',
        label: 'None',
        code: '',
      },
      ...options
    ];
  };

  useEffect(() => {
    dispatch(getTrRequest(match.params.show)).then((response) => {
      if (response.success) {
        setShowData(response.data);
      }
    });
  }, [dispatch, match.params.show]);

  useEffect(() => {
    setShowData(show_data);
  }, [show_data]);

  useEffect(() => {
    dispatch(getTrRequest(match.params.show));
  }, []);

  const sortItems = (items) => {
    return [...items].sort((a, b) => {
      if (a.department_name < b.department_name) return -1;
      if (a.department_name > b.department_name) return 1;
      return 0;
    });
  };

  const reduceItems = (items) => {
    const groupedItems = items.reduce((acc, curr) => {
      const values = {
        record_type: curr.order_number?.startsWith("F") ? "FakeOrder" : "Order",
        address: curr.address,
        pickup_address_id: curr.pickup_address_id,
        department_code: curr.department_code,
        group_uuid: curr.group_uuid,
        grouped: false,
      };

      if (curr.group_uuid !== null && curr.group_uuid !== "-") {
        const found = acc.findIndex(
          (item) => item.group_uuid === values.group_uuid
        );
        if (found === -1) {
          acc.push({
            ...values,
            order_ids: [curr.order_id],
            ids: [curr.id],
            grouped: true,
          });
        } else {
          acc[found].order_ids.push(curr.order_id);
          acc[found].ids.push(curr.id);
        }
      } else if (curr.group_uuid === "-") {
        acc.push({
          ...values,
          order_ids: [curr.order_id],
          ids: [curr.id],
          grouped: true,
        });
      } else {
        const found = acc.findIndex(
          (item) =>
            item.record_type === values.record_type &&
            item.address === values.address &&
            item.pickup_address_id === values.pickup_address_id &&
            item.department_code === values.department_code &&
            item.group_uuid === null
        );
        if (found === -1) {
          acc.push({
            ...values,
            order_ids: [curr.order_id],
            ids: [curr.id],
          });
        } else {
          acc[found].order_ids.push(curr.order_id);
          acc[found].ids.push(curr.id);
        }
      }

      return acc;
    }, []);

    return groupedItems;
  };

  const filterItems = (uniqueArr, sortedItems) => {
    return uniqueArr.map((curr) =>
      sortedItems.filter((item) => {
        return curr.ids.includes(item.id);
      })
    );
  };

  const applyFilters = (bigbox, filters) => {
    const { shipping_method, good, department_name, pickup_address, supplier } =
      filters;

    if (
      !shipping_method &&
      !good &&
      !department_name &&
      !pickup_address &&
      !supplier
    ) {
      return bigbox;
    }

    return bigbox.filter((arr) =>
      arr.some((val) => {
        if (good) {
          const goodLower = good.toLowerCase();
          const check_title = val.product_name
            ?.toLowerCase()
            .includes(goodLower);
          const check_code = val.bb_code?.toLowerCase().includes(goodLower);
          if (!check_title && !check_code) return false;
        }
        if (shipping_method && val.deliverie !== shipping_method) return false;
        if (department_name) {
          const dep = val.department_name || "";
          if (!dep.toLowerCase().includes(department_name.toLowerCase()))
            return false;
        }
        if (pickup_address) {
          if (pickup_address === "no_shipments") {
            if (val.pickup_addresses.length !== 0) return false;
          } else {
            if (!val.pickup_addresses.includes(pickup_address)) return false;
          }
        }
        if (supplier) {
          if (!val.supplier?.toLowerCase().includes(supplier.toLowerCase()))
            return false;
        }
        return true;
      })
    );
  };

  const bigbox = useMemo(() => {
    if (!showData?.tr_request_items) {
      return [];
    }

    const sortedItems = sortItems(showData.tr_request_items);
    const uniqueArr = reduceItems(sortedItems);
    const finalArray = filterItems(uniqueArr, sortedItems);

    return finalArray;
  }, [showData?.tr_request_items]);

  const bigbox_build = useMemo(() => {
    if (bigbox.length === 0) return [];
    return applyFilters(bigbox, filters);
  }, [filters, bigbox, loading]);

  const countings = useMemo(() => {
    const countSKUcodes = (arr) =>
      uniqueArray(arr.map((e) => e.map((d) => d.bb_code)).flat()).length;

    const total_rows = `${bigbox_build.reduce((prev, cur) => prev + cur.length, 0) || 0
      }/${bigbox.reduce((prev, cur) => prev + cur.length, 0) || 0}`;

    const total_product_qty = `${bigbox_build.reduce(
      (prev, cur) => prev + cur.reduce((prev, cur) => prev + cur.quantity, 0),
      0
    ) || 0
      }/${bigbox.reduce(
        (prev, cur) => prev + cur.reduce((prev, cur) => prev + cur.quantity, 0),
        0
      ) || 0
      }`;

    const total_sku = `${countSKUcodes(bigbox_build) || 0}/${countSKUcodes(bigbox) || 0
      }`;

    return {
      total_rows,
      total_product_qty,
      total_sku,
    };
  }, [bigbox_build, loading]);

  const orderModal = (order_id, id) => {
    const type = order_id.startsWith("FO") ? "FakeOrder" : "Order";
    if (type == "FakeOrder") {
      modalRef.current.openModal("FakeOrderShowModal");
      set_order_id(id);
      return;
    }
    set_order_id(order_id);
    dispatch(getOrder(id));
    modalRef.current.openModal("OrderShowModal");
  };

  const handleCheckboxChange = (id) => {
    setCheckedItems((prev) => {
      const isChecked = prev.includes(id);
      const updatedItems = isChecked
        ? prev.filter((item) => item !== id)
        : [...prev, id];
      return updatedItems;
    });
  };

  function compareTwoRecords(record1, record2) {
    const fieldsToCompare = [
      "record_type",
      "address",
      "pickup_address_id",
      "department_code",
    ];
    const mismatchedFields = [];

    for (let key of fieldsToCompare) {
      if (record1[key] !== record2[key]) {
        mismatchedFields.push({
          field: key,
          value1: record1[key],
          value2: record2[key],
        });
      }
    }

    if (mismatchedFields.length > 0) {
      mismatchedFields.forEach((mismatch) => {
        antdMessageError(
          `Mismatch found at field '${mismatch.field}': ${JSON.stringify(
            mismatch.value1
          )}`
        );
      });
      return false;
    }

    return true;
  }

  function compareAllRecords(records) {
    for (let i = 0; i < records.length - 1; i++) {
      for (let j = i + 1; j < records.length; j++) {
        if (!compareTwoRecords(records[i], records[j])) {
          return false;
        }
      }
    }
    return true;
  }

  const onGroupClick = () => {
    const filteredRecords = filterByIds(
      showData.tr_request_items,
      checkedItems
    );
    if (compareAllRecords(filteredRecords)) {
      groupTrRequestItems(checkedItems);
    }
  };

  const onUngroupClick = () => {
    const filteredRecords = filterByIds(
      showData.tr_request_items,
      checkedItems
    );
    if (compareAllRecords(filteredRecords)) {
      ungroupTrRequestItems(checkedItems);
    }
  };

  const filterByIds = (data, ids) => {
    return data.filter((item) => ids.includes(item.id));
  };

  const groupTrRequestItems = async (trRequestItemIds) => {
    try {
      const uuid = uuidv4();
      const updatePromises = trRequestItemIds.map((id) =>
        dispatch(updateTrRequestItem({ group_uuid: uuid, id }))
      );
      await Promise.all(updatePromises);
      await dispatch(getTrRequest(match.params.show));
      await setCheckedItems([]);
    } catch (error) {
      antdMessageError("Error grouping TR request items: " + error.message);
    }
  };

  const ungroupTrRequestItems = async (trRequestItemIds) => {
    try {
      const updatePromises = trRequestItemIds.map((id) =>
        dispatch(updateTrRequestItem({ group_uuid: "-", id }))
      );
      await Promise.all(updatePromises);
      await dispatch(getTrRequest(match.params.show));
      await setCheckedItems([]);
    } catch (error) {
      antdMessageError("Error ungrouping TR request items: " + error.message);
    }
  };

  const generateDocuments = async (type = "selected") => {
    let itemIds = [];

    if (type === "selected") {
      if (checkedItems.length === 0) {
        antdMessageError("Please select items first");
        return;
      }
      itemIds = checkedItems;
    } else if (type === "filtered") {
      itemIds = bigbox_build.flat().map(item => item.id);
      if (itemIds.length === 0) {
        antdMessageError("No filtered items available");
        return;
      }
    }

    try {
      const response = await axios.post('/api/v1/tr_request_items/create_inner_documents', {
        tr_request_item_ids: itemIds
      });

      if (response.data.success) {
        antdMessageSuccess(`Documents generated successfully for ${itemIds.length} items`);
        await dispatch(getTrRequest(match.params.show));
        setCheckedItems([]);
      }
    } catch (error) {
      antdMessageError("Error generating documents: " + error.message);
    }
  };

  return (
    <>
      <Container
        location={{
          locationName: showData?.number || "Nerastas",
          locationUrl: match.url,
        }}
        goBack={() => history.push("/technorama/tr_request")}
      >
        <>
          <>
            <ContentBlock>
              <div className="mx-3 my-1 d-flex align-items-center justify-content-between">
                <>
                  <div>
                    <span className="text-black font-weight-bold">
                      <>
                        <span>
                          <img
                            src={bigboxicon}
                            className="mr-2"
                            style={{ width: "20px", height: "20px" }}
                          />
                          No: {"  "}
                          {showData.id}
                        </span>
                        <span className="mx-3">
                          <FaList className="mr-2" size={20} />
                          Total product qty:{"  "}
                          {countings.total_product_qty}
                        </span>
                        <span className="mx-3">
                          <FaList className="mr-2" size={20} />
                          Total rows:{"  "}
                          {countings.total_rows}
                        </span>
                        <span className="mx-3">
                          <FaList className="mr-2" size={20} />
                          SKU qty:{"  "}
                          {countings.total_sku}
                        </span>

                        <span>
                          <MdDateRange className="mr-2" size={20} />
                          Creation date: {"  "}
                          {prettyDateFormat(showData.created_at)}
                        </span>
                      </>
                    </span>
                  </div>
                  <div className="d-flex justify-content-end flex-wrap">
                    <button
                      className="btn btn-sm btn-primary px-4 py-1"
                      onClick={() => history.push("/technorama/tr_request")}
                    >
                      Back
                    </button>
                    {!showData.exported_at ? (
                      <Tooltip placement="top" title={`Export to TECHNORAMA.`}>
                        <button
                          className="btn btn-sm btn-danger px-4 py-1 ml-2"
                          onClick={() => {
                            dispatch(exportTrRequests(showData.id));
                            history.push("/technorama/tr_request");
                          }}
                        >
                          Export to TR
                        </button>
                      </Tooltip>
                    ) : (
                      <Tooltip placement="top" title={`Update TECHNORAMA.`}>
                        <button
                          className="btn btn-sm btn-danger px-4 py-1 ml-2"
                          onClick={() => {
                            dispatch(exportTrRequests(showData.id, "update"));
                            history.push("/technorama/tr_request");
                          }}
                        >
                          Update TR
                        </button>
                      </Tooltip>
                    )}
                    {/* {show_data.call_back_at && (
                      <Tooltip placement="top" title={`Update TECHNORAMA.`}>
                        <button
                          className="btn btn-sm btn-danger px-4 py-1 ml-2"
                          onClick={() => {
                            dispatch(exportTrRequests(show_data.id, "update"));
                            history.push("/technorama/tr_request");
                          }}
                        >
                          Update TR
                        </button>
                      </Tooltip>
                    )} */}

                    {showData?.id && (
                      <Tooltip
                        placement="top"
                        title={
                          <div>
                            Export document like
                            <span
                              className="text-orange cursor-pointer white-hover font-semi-bold ml-1"
                              onClick={() =>
                                exportDocument(
                                  `/api/v1/tr_requests/${showData.id}/excel_download`,
                                  `test.xlsx`,
                                  "POST"
                                )
                              }
                            >
                              new
                            </span>{" "}
                            /{" "}
                            <span
                              className="text-orange cursor-pointer white-hover font-semi-bold ml-1"
                              onClick={() =>
                                exportDocument(
                                  `/api/v1/tr_requests/${showData.id}/excel_download`,
                                  `test.xlsx`,
                                  "POST",
                                  {
                                    type: "old",
                                  }
                                )
                              }
                            >
                              old
                            </span>{" "}
                            ?
                          </div>
                        }
                        trigger="click"
                      >
                        <button
                          className="btn btn-sm btn-success px-4 py-1 ml-2"
                          onClick={() => { }}
                        >
                          Export doc.
                        </button>
                      </Tooltip>
                    )}
                  </div>
                </>
              </div>
            </ContentBlock>

            {loading ? (
              <Spinner />
            ) : (
              <ContentBlock>
                <TableFilterBox
                  filter={true}
                  onFilter={() => setSearchActive((prev) => !prev)}
                  clearFilter={() =>
                    setFilters({
                      ...initialFilterState,
                    })
                  }
                  button1={
                    <>
                      <div className="ml-1 float-left">
                        <div className="dropdown d-inline-block">
                          <button
                            className="btn btn-sm btn-primary dropdown-toggle ml-2"
                            type="button"
                            id="generateDocumentsDropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Generate documents
                          </button>
                          <div className="dropdown-menu" aria-labelledby="generateDocumentsDropdown">
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                generateDocuments("selected");
                              }}
                            >
                              All selected {checkedItems.length}
                            </a>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                generateDocuments("filtered");
                              }}
                            >
                              All filtered {bigbox_build.flat().length}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="ml-1 float-left">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary ml-2"
                          onClick={() => onGroupClick()}
                        >
                          {"Group"}
                        </button>
                      </div>
                      <div className="ml-1 float-left">
                        <button
                          type="button"
                          style={{
                            backgroundColor: "#1f1a54",
                            color: "#fff",
                            borderColor: "#1f1a54",
                          }}
                          className="btn btn-sm btn-primary ml-2"
                          onClick={() => onUngroupClick()}
                        >
                          {"Ungroup"}
                        </button>
                      </div>
                    </>
                  }
                >
                  <div className="col-3 px-1">
                    <TextInputModal
                      text="Goods"
                      value={filters.good}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          setSearchActive((prev) => !prev);
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value || "";
                        setFilters((prev) => ({
                          ...prev,
                          good: value,
                        }));
                      }}
                    />
                  </div>
                  <div className="col-2 px-1">
                    <SelectInput
                      label="Shipping method"
                      options={[
                        {
                          label: "All",
                          value: "",
                        },
                        ...shipmentMethodOptions.map((value) => ({
                          value,
                          label: value,
                        })),
                      ]}
                      value={filters.shipping_method}
                      onChange={(shipping_method) => {
                        setFilters((prev) => ({
                          ...prev,
                          shipping_method,
                        }));
                      }}
                    />
                  </div>
                  <div className="col-3 px-1">
                    <DebounceSelect
                      label="Department"
                      showSearch={true}
                      value={filters.pickup_address || undefined}
                      placeholder={"Enter"}
                      fetchOptions={async (value) => {
                        try {
                          let api_url = `/api/v1/tr_requests/${showData.id}/pickup_addresses_options?q[code_i_cont_any]=${value}`;

                          const { data } = await Axios.get(api_url);
                          const valArr =
                            data?.data?.filter((d) => d.code) || [];
                          return (
                            [
                              {
                                label: "No data selected",
                                value: "",
                              },
                              {
                                label: "Has no available shipments",
                                value: "no_shipments",
                              },
                              ...valArr.map((e) => {
                                return {
                                  ...e,
                                  value: e.code,
                                  label: e.code,
                                };
                              }),
                            ] || []
                          );
                        } catch (err) {
                          errorHandler(err);
                          return [];
                        }
                      }}
                      onChange={(val) => {
                        setFilters((prev) => ({
                          ...prev,
                          pickup_address: val.value,
                        }));
                      }}
                      style={{
                        width: "100%",
                      }}
                    />
                  </div>
                  <div className="col-3 px-1">
                    <TextInputModal
                      text="VV department"
                      value={filters.department_name}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          setSearchActive((prev) => !prev);
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value || "";
                        setFilters((prev) => ({
                          ...prev,
                          department_name: value,
                        }));
                      }}
                    />
                  </div>
                </TableFilterBox>

                <div className="table-responsive mt-2">
                  <table className="table table-sm table-hover mt-3">
                    <thead>
                      <tr
                        className="text-black font-semi-bold text-base"
                        style={{
                          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <th>Order ID</th>
                        <th>Client</th>
                        <th>QTY</th>
                        <th>Stock QTY</th>
                        <th>BB code</th>
                        <th>Goods</th>
                        <th>Supplier code</th>
                        <th>Shipping method</th>
                        <th colSpan={2}>Shipment number</th>
                        <th>Departments</th>
                        <th>VV department</th>
                        <th>Inner Document</th>
                        <th>Comments</th>
                        <th>Cost price</th>
                        <th>
                          {!showData.exported_at && (
                            <AiOutlinePlus
                              style={{ width: 25, height: 25 }}
                              title="New"
                              className="cursor-pointer text-success grow"
                              onClick={() => {
                                setShowModal(true);
                              }}
                              size={"20px"}
                            />
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {bigbox_build.map((items, index) => {
                        const multiple = items.map((d) => ({
                          order_row_id: d.order_row_id,
                          order_id: d.order_id,
                          order_ids: d.order_ids,
                          quantity: d.quantity,
                          tr_request_item_id: d.id,
                          supplier: d.supplier,
                          department_code: d.department_code,
                          department_name: d.department_name,
                          department_address_id: d.department_address_id,
                        }));
                        const multipleCount = multiple.length;
                        const lastItem = last_arr(items);
                        return (
                          <React.Fragment
                            key={
                              index +
                              `tr_request_item_parent_${lastItem?.order_id || "None"
                              }_${lastItem?.pickup_address_id || "None"}`
                            }
                          >
                            {items.map((item, idx) => {
                              return (
                                <tr
                                  key={`tr_request_item_${item.order_id}_${item.id}`}
                                  style={borderFunction(idx + 1, multipleCount)}
                                >
                                  <TableColumn
                                    {...item}
                                    rowSpan={
                                      multipleCount > 1
                                        ? idx == 0
                                          ? multipleCount
                                          : 0
                                        : 1
                                    }
                                    disabled={
                                      !!showData.exported_at ||
                                      item.canceled_at
                                    }
                                    orderModal={orderModal}
                                    multiple={multiple}
                                    checked={checkedItems.includes(item.id)}
                                    onCheckboxChange={() =>
                                      handleCheckboxChange(item.id)
                                    }
                                    showData={showData}
                                    setShowData={setShowData}
                                    match={match}
                                    departmentOptions={getDepartmentOptions()}
                                    onUpdateDepartment={updateDepartmentMutation.mutate}
                                    isUpdatingDepartment={updateDepartmentMutation.isLoading}
                                    history={history}
                                  />
                                </tr>
                              );
                            })}
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </ContentBlock>
            )}
          </>
        </>
      </Container>
      {showModal && <TrRequestAddItem onHandler={() => setShowModal(false)} trRequestID={showData?.id} />}
      <div id="modal-roots" />
      <RegularOrderChildren
        ref={modalRef}
        requiredOrderId={order_id}
        modal_type={"TrRequest"}
      />
    </>
  );
}

export default TrRequestIdScreen;

const borderFunction = (idx, length) => {
  const val = {
    background: length > 1 ? "#F9FDFF" : null,
  };
  if (length > 1) {
    val.borderRight = "1px solid #46C5F9";
    val.borderLeft = "1px solid #46C5F9";
    if (idx == 1) {
      val.borderTop = "1px solid #46C5F9";
      val.borderBottom = "1px solid rgba(166, 227, 252, 0.6)";
    } else if (idx == length) {
      val.borderBottom = "1px solid #46C5F9";
    } else if (idx !== length) {
      val.borderBottom = "1px solid rgba(166, 227, 252, 0.6)";
    }
  }
  return val;
};

const TrRequestAddItem = ({ onHandler, trRequestID }) => {
  const dispatch = useDispatch();

  return (
    <Modal
      title="Add product"
      visible={true}
      onCancel={onHandler}
      cancelText="Close"
      okButtonProps={{ style: { display: "none" } }}
    >
      <OrderRowAdd
        orderId={"1"}
        postOrderRowGoods={async (body, orderId, rowGoods) => {
          try {
            const { data } = await Axios.post(
              `/api/v1/tr_request_items`,
              {
                tr_request_id: trRequestID,
                tr_request_item: body,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            if (data.success) {
              antdMessageSuccess("Product added successfully");
              onHandler();
              window.location.reload();
            }
          } catch (error) {
            errorHandler(error);
          }
        }}
      />
    </Modal>
  );
};

const SplitItemModal = ({
  visible,
  onCancel,
  onSplit,
  itemData,
  isLoading
}) => {
  const [splitQuantity, setSplitQuantity] = useState(1);
  const maxQuantity = itemData?.quantity || 1;
  const remainingQuantity = maxQuantity - splitQuantity;

  const handleOk = () => {
    if (splitQuantity <= 0 || splitQuantity >= maxQuantity) {
      antdMessageError("Split quantity must be between 1 and " + (maxQuantity - 1));
      return;
    }
    onSplit(splitQuantity, remainingQuantity);
  };

  return (
    <Modal
      title={
        <div className="d-flex align-items-center">
          <MdCallSplit className="mr-2 text-warning" size={20} />
          <span>Split Item</span>
        </div>
      }
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={isLoading}
      okText="Split"
      cancelText="Cancel"
      width={480}
      bodyStyle={{ padding: '16px' }}
    >
      {/* Compact Item Info */}
      <div className="bg-light p-3 rounded mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <small className="text-muted">Product</small>
            <div className="font-weight-bold" style={{ fontSize: '14px' }}>
              {itemData?.product_name || 'Unknown Product'}
            </div>
          </div>
          <div className="text-right">
            <small className="text-muted">BB Code</small>
            <div className="font-weight-bold text-primary" style={{ fontSize: '14px' }}>
              {itemData?.bb_code || '-'}
            </div>
          </div>
        </div>
      </div>

      {/* Split Input */}
      <div className="row align-items-center mb-3">
        <div className="col-4">
          <label className="mb-0 font-weight-bold" style={{ fontSize: '14px' }}>
            Split Quantity:
          </label>
        </div>
        <div className="col-8">
          <Input
            type="number"
            min={1}
            max={maxQuantity - 1}
            value={splitQuantity}
            onChange={(e) => setSplitQuantity(Number(e.target.value))}
            placeholder="Enter quantity"
            size="small"
            style={{ width: '120px' }}
          />
          <small className="text-muted ml-2">
            (1 - {maxQuantity - 1})
          </small>
        </div>
      </div>

      {/* Results Preview */}
      <div className="border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="row text-center">
          <div className="col-6">
            <div className="border-right">
              <small className="text-muted">Original Item</small>
              <div className="h5 mb-0 text-info">{remainingQuantity}</div>
              <small>units</small>
            </div>
          </div>
          <div className="col-6">
            <small className="text-muted">New Item</small>
            <div className="h5 mb-0 text-success">{splitQuantity}</div>
            <small>units</small>
          </div>
        </div>
      </div>
    </Modal>
  );
};

function TableColumn({
  id,
  order_number,
  client,
  bb_code,
  product_name,
  rivile_code,
  supplier_code,
  pickup_address_id,
  deliverie,
  department_code,
  department_name,
  numbers_status,
  pickup_addresses,
  manager_comment,
  tr_comment,
  admin_comment,
  disabled,
  order_id,
  order_row_id,
  canceled_at,
  returned,
  total_cost,
  prime_cost,
  orderModal,
  stock_quantity,
  quantity,
  canceled,
  order_row_ids,
  rowSpan,
  multiple,
  carrier,
  checked,
  onCheckboxChange,
  match,
  showData,
  setShowData,
  departmentOptions,
  onUpdateDepartment,
  isUpdatingDepartment,
  tr_inner_document_id,
  tr_inner_document_error,
  tr_inner_document,
  history,
  quantities,
}) {
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    rivile_code,
    deliverie,
    quantity,
    client,
    bb_code,
    product_name,
    manager_comment,
  });
  const [selectedDepartment, setSelectedDepartment] = useState("");

  const getQuantityForDepartment = (departmentCode) => {
    if (!quantities || !Array.isArray(quantities) || !departmentCode) {
      return null;
    }

    const departmentWithPrefix = `vv_${departmentCode.toLowerCase()}`;
    const quantityItem = quantities.find(q => q.supplier === departmentWithPrefix);

    return quantityItem ? quantityItem.quantity : null;
  };

  useEffect(() => {
    if (client == values.client && deliverie == values.deliverie) return;
    setValues((prev) => ({
      ...prev,
      client,
      deliverie,
    }));
  }, [client, deliverie]);
  const [visible, setVisible] = useState(false);
  const [splitModalVisible, setSplitModalVisible] = useState(false);
  const [isProcessingSplit, setIsProcessingSplit] = useState(false);

  useDebounce(() => dispatch(updateTrRequestItem({ ...values, id })), 1000, [
    values.rivile_code,
    values.deliverie,
    values.quantity,
    values.client,
    values.bb_code,
    values.product_name,
    values.manager_comment,
  ]);

  const order_type = order_number?.startsWith("FO") ? "FakeOrder" : "Order";
  const available_create_shipment = multiple.every(
    (d) => !!d.order_id && !!d.order_row_id
  );





  const onDelete = async (deleteId) => {
    await dispatch(removeMTrRequestItem(deleteId));

    setShowData((prevData) => {
      const updatedItems = prevData.tr_request_items.map(item => {
        if (item.id === deleteId) {
          return {
            ...item,
            canceled_at: item.canceled_at ? null : new Date().toISOString(),
          };
        }
        return item;
      });
      return {
        ...prevData,
        tr_request_items: updatedItems,
      };
    });
  };

  const handleSplit = async (splitQuantity, remainingQuantity) => {
    setIsProcessingSplit(true);
    try {
      const response = await Axios.post(`/api/v1/tr_request_items/${id}/split`, {
        quantity: splitQuantity
      });

      if (!response.data?.success) {
        throw new Error(response.data?.message || 'Failed to split TR item');
      }

      const refreshResult = await dispatch(getTrRequest(match.params.show));
      if (refreshResult && refreshResult.success) {
        setShowData(refreshResult.data);
      }

      antdMessageSuccess(`Item split successfully! Original: ${remainingQuantity}, New: ${splitQuantity}`);
      setSplitModalVisible(false);

    } catch (error) {
      console.error('Split failed:', error);
      antdMessageError('Failed to split item: ' + (error.response?.data?.message || error.message));
    } finally {
      setIsProcessingSplit(false);
    }
  };

  return (
    <>
      <SplitItemModal
        visible={splitModalVisible}
        onCancel={() => setSplitModalVisible(false)}
        onSplit={handleSplit}
        itemData={{
          id,
          client,
          bb_code,
          product_name,
          rivile_code,
          quantity,
          deliverie,
          manager_comment,
        }}
        isLoading={isProcessingSplit}
      />
      <td className="align-middle">
        <div className="d-flex felx-row">
          <Checkbox
            className="mr-1"
            onChange={onCheckboxChange}
            checked={checked}
          />
          <div
            className="text-primary cursor-pointer text-decoration-underline
          "
            onClick={() => {
              orderModal(order_number, order_id);
            }}
          >
            {order_number}
          </div>
        </div>
      </td>
      <td className="align-middle">
        <TextInputModal
          disabled={disabled}
          value={values.client}
          onChange={(e) => {
            const client = e.target.value;
            setValues((prev) => ({ ...prev, client }));
          }}
        />
      </td>{" "}
      <td className="align-middle">
        <TextInputModal
          disabled={disabled}
          value={values.quantity}
          onChange={(e) => {
            const quantity = e.target.value;
            setValues((prev) => ({ ...prev, quantity }));
          }}
        />
      </td>
      <td className="align-middle">
        {stock_quantity || 0}
      </td>
      <td className="align-middle">
        <TextInputModal
          disabled={values.bb_code ? disabled || order_number : false}
          value={values.bb_code}
          onChange={(e) => {
            const bb_code = e.target.value;
            setValues((prev) => ({ ...prev, bb_code }));
          }}
        />
      </td>
      <td className="align-middle">
        {disabled ? (
          <>
            <div>
              {rivile_code}
              <IconDot className="mx-2 text-orange" />
            </div>
            {product_name}
          </>
        ) : (
          <div className="d-flex align-items-center flex-column">
            <TextInputModal
              placeholder="Rivile code"
              value={values.rivile_code}
              onChange={(e) => {
                const rivile_code = e.target.value;
                setValues((prev) => ({ ...prev, rivile_code }));
              }}
            />
            <TextInputModal
              placeholder="Product name"
              value={values.product_name}
              onChange={(e) => {
                const product_name = e.target.value;
                setValues((prev) => ({ ...prev, product_name }));
              }}
            />
          </div>
        )}
      </td>
      <td className="align-middle">
        {multiple?.[0]?.supplier?.title || supplier_code}
      </td>
      <td className="align-middle">
        <SelectForm
          disabled={disabled}
          options={shipmentMethodOptions.map((d) => ({ value: d, label: d }))}
          value={values.deliverie}
          onChange={(deliverie) =>
            setValues((prev) => ({ ...prev, deliverie }))
          }
        />
      </td>
      {!!rowSpan && (
        <td className="align-middle" rowSpan={rowSpan}>
          {available_create_shipment && (
            <>
              {visible ? (
                <CreateShipment
                  setVisible={setVisible}
                  order_id={order_id}
                  pickup_address_id={pickup_address_id}
                  order_type={order_type}
                  multiple={multiple}
                  bb_code={values.bb_code}
                />
              ) : (
                <div
                  className="btn-primary d-flex justify-content-center align-items-center cursor-pointer"
                  style={{ width: 30, height: 30, borderRadius: "50%" }}
                  onClick={() => setVisible(true)}
                >
                  <img
                    src={ShipmentStoreSvg}
                    style={{ width: 18, height: 18, marginLeft: 2 }}
                  />
                </div>
              )}
            </>
          )}
        </td>
      )}
      <td className="align-middle">
        {numbers_status.map((d, idx) => (
          <Tooltip
            key={d.number + "_" + idx}
            placement="left"
            title={`Department: ${d.department || "None"}`}
          >
            <a
              key={`${d.number}_${idx}`}
              className={colorBlockShipment(d)}
              style={{ fontSize: "0.8rem" }}
              href={d.url}
              target="_blank"
            >
              {d.number}
              <br />
            </a>
          </Tooltip>
        ))}
      </td>
      <td className="align-middle">
        {pickup_addresses.map((d) => (
          <div key={JSON.stringify(d)} className="d-flex align-items-center">
            <IconDot className="mr-2 text-primary" />
            {d}
          </div>
        ))}
      </td>
      <td className="align-middle">
        <div className="d-flex align-items-center">
          <div className="d-flex flex-column">
            <div className="d-flex align-items-center">
              <span className="mr-2">{department_name} - {department_code}</span>
              {!disabled && !tr_inner_document_id && (
                <VvDepartmentPopover
                  itemId={id}
                  onSave={onUpdateDepartment}
                  currentDepartmentCode={department_code}
                  currentDepartmentName={department_name}
                  departmentOptions={departmentOptions}
                  isEditing={true}
                  quantities={quantities}
                />
              )}
            </div>
            {department_code && (
              <div className="mt-1">
                <small className="text-muted">
                  Stock qty: {' '}
                  <span className="font-weight-bold text-info">
                    {getQuantityForDepartment(department_code) ?? '-'}
                  </span>
                </small>
              </div>
            )}
          </div>
        </div>
      </td>
      <td className="align-middle">
        {tr_inner_document_id ? (
          <div
            className="text-primary cursor-pointer text-decoration-underline"
            onClick={() => {
              history.push(`/technorama/documentDetails?id=${tr_inner_document_id}`);
            }}
          >
            {
              tr_inner_document_error ? (
                <Tooltip title={tr_inner_document_error}>
                  <span style={{ color: 'red' }}>Error!</span>
                </Tooltip>
              ) :
              <span>{tr_inner_document?.inner_document_number || tr_inner_document_id}</span>
            }
          </div>
        ) : (
          "-"
        )}
      </td>
      <td className="align-middle">
        {disabled || order_type == "Order" ? (
          <>
            <div className="font-semi-bold text-xs">Management comments</div>
            <div className="col-12 p-2 border border rounded bg-white text-xs">
              {manager_comment}
            </div>
          </>
        ) : (
          <>
            <div className="font-semi-bold text-xs">Management comments</div>
            <TextAreaFieldGroup
              rows={2}
              disabled={disabled}
              value={values.manager_comment}
              onChange={(e) => {
                const manager_comment = e.target.value;
                setValues((prev) => ({ ...prev, manager_comment }));
              }}
            />
          </>
        )}
        {admin_comment && (
          <>
            <div className="font-semi-bold text-xs">Admin comments</div>
            <div className="col-12 p-2 border border rounded bg-white text-xs">
              {admin_comment}
            </div>
          </>
        )}
        {tr_comment && (
          <>
            <div className="font-semi-bold text-xs">Technorama comments</div>
            <div className="col-12 p-2 border border rounded bg-white text-xs">
              {tr_comment}
            </div>
          </>
        )}
      </td>
      <td className="align-middle">
        <div className="d-flex align-items-center">
          <div className="mr-2">
            <div className="d-flex flex-row align-items-center">
              {prime_cost ? (
                <Tooltip title="Cost price after bonus (adjustable only in documents)">
                  <span style={{ color: "#666", fontSize: "12px" }}>Cost price:</span>
                </Tooltip>
              ) : (
                <span style={{ color: "#ccc", fontSize: "12px" }}>Cost price:</span>
              )}
              <span style={{ color: prime_cost ? "#000" : "#ccc" }}>
                {prime_cost ? `${prime_cost} €` : "No cost price"}
              </span>
            </div>
            <div className="d-flex flex-row align-items-center">
              {total_cost ? (
                <Tooltip title="Cost price +2% (adjustable only in documents)">
                  <div style={{ backgroundColor: "#E0E0E0", padding: "2px 4px", borderRadius: "18px", marginRight: 4 }}>
                    <p style={{ fontSize: "10px", color: "#00000073", margin: 0, whiteSpace: "nowrap" }}>D +2%</p>
                  </div>
                </Tooltip>
              ) : (
                <div style={{ backgroundColor: "#f5f5f5", padding: "2px 4px", borderRadius: "18px", marginRight: 4 }}>
                  <p style={{ fontSize: "10px", color: "#ccc", margin: 0, whiteSpace: "nowrap" }}>D +2%</p>
                </div>
              )}
              <span style={{ color: total_cost ? "#000" : "#ccc" }}>
                {total_cost ? `${total_cost} €` : "No cost price"}
              </span>
            </div>
          </div>
        </div>
      </td>
      <td className="align-middle">
        <div className="d-flex align-items-center justify-content-end">
          {returned && (
            <>
              <Tooltip placement="top" title={`Returned`}>
                <MdOutlineAssignmentReturned className="text-danger" />
              </Tooltip>
              <div className="mx-1"></div>
            </>
          )}

          {/* Split button - only show if quantity > 1 and not disabled */}
          {quantity > 1 && !disabled && !canceled_at && (
            <>
              <Tooltip placement="top" title="Split item into multiple quantities">
                <button
                  className="btn btn-sm btn-warning"
                  style={{
                    width: 31,
                    height: 31,
                    marginRight: 8,
                  }}
                  onClick={() => setSplitModalVisible(true)}
                >
                  <MdCallSplit color="#fff" />
                </button>
              </Tooltip>
            </>
          )}

          {canceled_at ? (
            <div>
              <Tooltip
                placement="left"
                title={`${canceled || "Canceled"} ${prettyDateFormat(
                  canceled_at
                )}`}
              >
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    confirm({
                      title: "Are you sure you want to restore?",
                      icon: <IconExclamation className="text-primary" />,
                      content: "You will not be able to undo this action",
                      onOk() {
                        onDelete(id);
                        console.log("OK");
                      },
                      onCancel() {
                        console.log("Cancel");
                      },
                    });
                  }}
                >
                  <IconCancel />
                </div>
              </Tooltip>
            </div>
          ) : (
            <button
              className="btn btn-sm btn-danger"
              style={{
                width: 31,
                height: 31,
              }}
              onClick={() =>
                confirm({
                  title: "Are you sure?",
                  icon: <IconExclamation className="text-primary" />,
                  content: "You will not be able to undo this action",
                  onOk() {
                    onDelete(id);
                    console.log("OK");
                  },
                  onCancel() {
                    console.log("Cancel");
                  },
                })
              }
            >
              <XIcon color="#fff" />
            </button>
          )}
        </div>
      </td>
    </>
  );
}

const CreateShipment = ({
  setVisible,
  order_id,
  pickup_address_id,
  order_type = "Order",
  multiple,
  bb_code
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        const promises = multiple.map(async ({ order_id }) => {
          const endpoint =
            order_type === "FakeOrder"
              ? `/api/v1/fake_orders/${order_id}`
              : `/api/v1/orders/${order_id}`;

          const response = await Axios.get(endpoint);
          if (response.data?.order)
            return {
              ...response.data.order,
              invoices: response.data?.invoices,
            };
          return {};
        });

        const data = await Promise.all(promises);

        let values = {
          order_rows: [],
          shipments: [],
          order_ids: [],
        };

        data.forEach((order) => {
          console.log(order);
          const filteredOrderRows = order.order_rows.filter(
            (f_row) => !values.order_rows.find((o_row) => o_row.id === f_row.id)
          );
          const filteredShipments = order.shipments.filter(
            (f_row) => !values.shipments.find((o_row) => o_row.id === f_row.id)
          );
          values = {
            ...values,
            ...order,
            order_rows: [...values.order_rows, ...filteredOrderRows],
            shipments: [...values.shipments, ...filteredShipments],
            order_ids: [...values.order_ids, order.id],
          };
        });

        console.log({ values });
        setValue({
          order: values,
        });
      } catch (error) {
        console.error("An error occurred while fetching orders::", error);
        setError("Ups...");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
    console.log({ multiple });
  }, []);

  const callBackOnCreate = async (val, data) => {
    try {
      console.log({ val, data });
      if (!val) return;
      multiple.forEach(async ({ tr_request_item_id }) => {
        await dispatch(
          getTrRequestItem(tr_request_item_id, data?.shipment?.id)
        );
        orderRowsChange({ type: "UPDATE_ITEM", data });
      });
      setVisible(false);
    } catch (err) {
      console.log(err);
    }
  };

  const orderRowsChange = ({ type, data }) => {
    if (type == "UPDATE_SELECTED") {
      return setValue((prev) => ({
        ...prev,
        order: {
          ...prev.order,
          order_rows: prev.order.order_rows.map((d) => {
            const selected = d.id == data.order_row_id;
            return selected ? { ...d, selected: data.selected } : d;
          }),
        },
      }));
    }
    setValue((prev) => {
      let values_obj = {
        order_rows: prev.order.order_rows.map((order_row) => {
          const findOrderRow = data.order_rows.find(
            (findOrderRow) => findOrderRow.id == order_row.id
          );
          if (findOrderRow) {
            return {
              ...order_row,
              ...findOrderRow,
            };
          }
          return order_row;
        }),
        shipments: prev.order.shipments,
      };
      if (data.shipment) {
        values_obj.shipments.push(data.shipment);
      } else if (data.shipments) {
        values_obj.shipments = data.shipments;
      }
      return {
        ...prev,
        order: {
          ...prev.order,
          ...values_obj,
        },
      };
    });
  };

  const extra_values = useMemo(() => {
    console.count("extra_values");
    let default_val = {
      order_rows: [],
      shipments: [],
    };
    if (!value || error || loading) return default_val;
    if (order_type === "Order" && !value?.order) return default_val;

    const order = value.order;
    default_val.shipments = order.shipments;
    default_val.order_rows = order.order_rows.map((d) => {
      if (have_product_reference(d.product_reference)) {
        const trRequestItem = multiple.find(
          (s) => s.order_row_id === d.id
        );
        return {
          ...d,
          selected: d.hasOwnProperty("selected")
            ? d.selected
            : trRequestItem ? true : false,
          quantity: trRequestItem?.quantity || d.quantity,
        };
      } else if (
        d.shipments_count < +d.quantity &&
        [
          isOrderRowCod(d.id_product, order.order_shop_id),
          multiple.some((s) => s.order_row_id === d.parent_id),
        ].includes(true)
      ) {
        return {
          ...d,
          quantity: +d.quantity - d.shipments_count,
          selected: d.hasOwnProperty("selected")
            ? d.selected
            : d.disabled_at === null,
        };
      }
      return d;
    });

    return default_val;
  }, [error, loading, value?.order?.order_rows, value?.order?.shipments]);

  const values = useMemo(() => {
    console.count("values");
    if (!value || error || loading) return {};
    if (order_type == "Order" && !value?.order) return {};
    const order = value.order;
    let values_obj = {
      id: order.id || value.id,
      remark: order.remark,
      orderRowsChange: orderRowsChange,

      total_price: order.total_price,
      payment_module: order.payment_module,
      order_invoices: order?.invoices || [],
      carrier: order.carrier,
      order_cart_rules: order?.order_cart_rules || [],
      assigned_bills: order.assigned_bills,
      onClose: () => setVisible(false),
      cod: order.cod,
      leasing_cod: order.leasing_cod,
      leasing_advance: order.leasing_advance,
      waiting_payments: order?.waiting_payments || [],
      order_shop_id: order.order_shop_id || value.order_shop_id,
      order_shop: order.order_shop || value.order_shop,
      callBackOnCreate: callBackOnCreate,
      pickup_address_id: multiple[0]?.department_address_id,
      form_type: order_type,
      multiple,
      total_shipping_tax_incl:
        possibilityToAssignDeliveryAmount({
          shipments: order.shipments,
          orderInfo: order,
        }) || 0,
    };

    values_obj.shipping_address = order.shipping_address || {
      country_id: order.order_shop?.country_id,
      firstname: "",
      lastname: "",
      street: "",
      postal_code: "",
      city: "",
      other: "",
      phone: "",
      company: null,
      vat_code: null,
      parcel_terminal_id: null,
      company_code: null,
      registered_in_rivile: null,
      remark: "",
      valid_phone: true,
    };

    values_obj.billing_address = order.billing_address || order.shipping_address || values_obj.shipping_address;

    return values_obj;
  }, [error, loading]);

  if (loading) {
    return (
      <div>
        <Spin />
      </div>
    );
  }
  if (error) {
    const json_error = JSON.stringify(error);
    if (json_error.length > 255) {
      return <div>Something went wrong. Please contact administrator</div>;
    }
    return <div>{JSON.stringify(error)}</div>;
  }
  if (Object.entries(values).length == 0) {
    return <div>Loading for information</div>;
  }

  const department_code = multiple[0]?.department_code || '';
  const department_name = multiple[0]?.department_name || '';
  return (
    <>
      <TrShipmentComponentIndex
        {...values}
        shipments={extra_values.shipments}
        order_rows={extra_values.order_rows}
        department_code={department_code}
        department_name={department_name}
      />
    </>
  );
};
